import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'
import { MobileTabBar } from '@/components/generals/mobile-tab-bar'

export const Layout: FC<LayoutProps> = ({
    children,
    searchOptions,
    showHeaderSearch = true,
    showTabBar = true,
    showFooter = true,
    wideHeader = false,
    bottomBar = false
}): ReactNode => {
    return (
        <div className={cn('flex min-h-screen flex-col', showTabBar && 'pb-16 md:pb-0', bottomBar && 'pb-20 lg:pb-0')}>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:rounded-full focus:bg-foreground focus:px-4 focus:py-2 focus:text-sm focus:text-background'
            >
                Skip to content
            </a>

            <SiteHeader searchOptions={searchOptions} showSearch={showHeaderSearch} wide={wideHeader} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            {showFooter && <SiteFooter areas={searchOptions?.areas} />}
            {showTabBar && <MobileTabBar />}
        </div>
    )
}
